import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Troubleshoot = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Troubleshoot' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,5 C1,3.00000024 2,1 3,1 C3,1 5,5 5,5 L7,5 C7,5 9,1 9,1 C10,1 11,3.00000006 11,5 C11,7.25400025 10,9.0000003 8,10 L8,21 C8,22 8,23 6,23 C4,23 4,22 4,21 L4,10 C2,9.0000003 1,7.25400042 1,5 Z M19,12 L19,18 M17,18 L18,23 L20,23 L21,18 L17,18 Z M14,12 L24,12 L14,12 Z M21,12 L21,3 C21,1.895 20.105,1 19,1 C17.895,1 17,1.895 17,3 L17,12' />
  </StyledIcon>
);
